import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const FinalCTA = () => {
  const navigate = useNavigate();

  return (
    <section className="py-16 sm:py-20 md:py-28 bg-foreground text-background">
      <div className="container mx-auto px-4">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold mb-4 leading-tight px-4">
            Your data is already messy.
            <br />
            <span className="text-muted-foreground">Let something else deal with it.</span>
          </h2>
          
          <Button 
            size="lg"
            variant="secondary"
            className="h-12 px-6 sm:px-8 text-base font-medium mt-6 sm:mt-8 group bg-background text-foreground hover:bg-background/90 w-full sm:w-auto touch-target"
            onClick={() => navigate("/auth")}
          >
            Open Strata
            <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
          </Button>
        </div>
      </div>
    </section>
  );
};
